export const API_URL = 'https://hellogassy-backend.onrender.com/api';
// export const API_URL = 'http://localhost:4000/api'

export const API_TIMEOUT = 10000; // 10 seconds timeout 